import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RequestsService } from '../services/utils/requests.service';
import { HardwareService } from '../services/hardware.service';

export const logsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const hardware = inject(HardwareService);
  if (hardware.isMobile()) return router.parseUrl('/witaMobile');
  return inject(RequestsService).getCurrentUser()?.role === 'superuser' ? true : router.parseUrl('/wita/mentorage');
};
